import { render, staticRenderFns } from "./MigrationHeader.vue?vue&type=template&id=4b7e55ea&scoped=true&"
import script from "./MigrationHeader.vue?vue&type=script&lang=js&"
export * from "./MigrationHeader.vue?vue&type=script&lang=js&"
import style0 from "./MigrationHeader.vue?vue&type=style&index=0&id=4b7e55ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e55ea",
  null
  
)

export default component.exports